const Row = {
  isComponent: el => el.tagName === 'DIV' && el.classList.contains('row'),
  model: {
    defaults: Object.assign({}, {
      name: 'Row',
      tagName: 'div',
      draggable: true,
      droppable: true,
      copyable: true,
      attributes: {
        id: 'row'
      },
      traits: [
        {
          name: 'id',
          label: 'ID',
          placeholder: 'ID',
          type: 'text'
        },
        {
          name: 'attr-gutters',
          type: 'select',
          label: 'Gutters',
          placeholder: 'Gutters',
          options: [
            'default',
            'dense',
            'no-gutters'
          ]
        },
        {
          name: 'attr-align',
          label: 'Align',
          placeholder: 'Align',
          type: 'select',
          options: [
            'default',
            'start',
            'center',
            'end',
            'baseline',
            'stretch'
          ]
        },
        {
          name: 'attr-align-content',
          label: 'Align content',
          placeholder: 'Align content',
          type: 'select',
          options: [
            'default',
            'start',
            'center',
            'end',
            'space-between',
            'space-around',
            'stretch'
          ]
        },
        {
          name: 'attr-justify',
          label: 'Justify',
          placeholder: 'Justify',
          type: 'select',
          options: [
            'default',
            'start',
            'center',
            'end',
            'space-between',
            'space-around'
          ]
        }
      ]
    }),
    init() {
      // this.handleGuttersChange()
      // this.handleAlignChange()
      // this.handleAlignContentChange()
      // this.handleJustifyChange()
      this.on('change:attributes:attr-gutters', this.handleGuttersChange)
      this.on('change:attributes:attr-align', this.handleAlignChange)
      this.on('change:attributes:attr-align-content', this.handleAlignContentChange)
      this.on('change:attributes:attr-justify', this.handleJustifyChange)
    },
    handleGuttersChange() {
      const targetAttr = this.getAttributes()['attr-gutters']
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /row--dense|no-gutters/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr === 'dense') {
        this.addClass('row--dense')
      }
      if (targetAttr === 'no-gutters') {
        this.addClass('no-gutters')
      }
    },
    handleAlignChange() {
      const targetAttr = this.getAttributes()['attr-align']
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /align-(start|center|end|baseline|stretch)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr !== 'default') {
        this.addClass(`align-${targetAttr}`)
      }
    },
    handleAlignContentChange() {
      const targetAttr = this.getAttributes()['attr-align-content']
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /align-content-(start|center|end|space-between|space-around|stretch)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr !== 'default') {
        this.addClass(`align-content-${targetAttr}`)
      }
    },
    handleJustifyChange() {
      const targetAttr = this.getAttributes()['attr-justify']
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /justify-(start|center|end|space-between|space-around)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr !== 'default') {
        this.addClass(`justify-${targetAttr}`)
      }
    }
  }
}

export default Row
